var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBalloon = function SvgIconBalloon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.467 5.623a1 1 0 1 0-.684 1.88 2.45 2.45 0 0 1 1.465 1.464 1 1 0 1 0 1.88-.684 4.45 4.45 0 0 0-2.661-2.66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.926 16.254c.869 1.05 1.957 1.935 3.197 2.492L8.071 21.38A1 1 0 0 0 9 22.749h6a1 1 0 0 0 .929-1.37l-1.052-2.633c1.24-.557 2.328-1.443 3.197-2.492 1.491-1.8 2.426-4.177 2.426-6.504a8.5 8.5 0 1 0-17 0c0 2.327.935 4.704 2.426 6.504M12 3.25a6.5 6.5 0 0 0-6.5 6.5c0 1.817.743 3.752 1.966 5.229.902 1.089 2.018 1.876 3.223 2.213l.024.007q.63.174 1.287.176a4.9 4.9 0 0 0 1.311-.183c1.205-.337 2.32-1.124 3.223-2.213 1.223-1.477 1.966-3.412 1.966-5.229a6.5 6.5 0 0 0-6.5-6.5m-1.524 17.5.576-1.442a6.8 6.8 0 0 0 1.896 0l.576 1.442z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconBalloon;